module.exports = __webpack_public_path__ + "img/1.8464899b.png";